module.exports = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g stroke=\"#979797\" stroke-linecap=\"round\" stroke-width=\"2\">\n    <path d=\"M12.375 14.375L8 10M3.625 14.375L8 10\"/>\n  </g>\n  <rect fill=\"#979797\" width=\"16\" height=\"2\" rx=\"1\"/>\n  <rect fill=\"#979797\" y=\"4\" width=\"16\" height=\"2\" rx=\"1\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/collapse-list.svg
// module id = 787
// module chunks = 1